/**
 * Resmi işletme bilgileri — footer, sözleşmeler, iletişim ve Merchant Center ile aynı olmalı.
 */
export const BUSINESS = {
  brandName: 'LeaserTech',
  storeType: 'Online Mağaza',
  taxNumber: '34852246880',
  taxOffice: 'Küçükyalı Vergi Dairesi',
  address: 'Cevizli Mah. Gültutan Sokak No:2 D:4 Maltepe / İstanbul',
  phone: '+90 538 316 14 62',
  phoneDisplay: '+90 538 316 14 62',
  emailInfo: 'info@leasertech.com',
  emailContact: 'bsametakkaya@gmail.com',
  website: 'https://leasertech.com',
  websiteDisplay: 'www.leasertech.com',
};

export const businessEmailList = `${BUSINESS.emailInfo}, ${BUSINESS.emailContact}`;
